/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { SearchableItem } from './interface/searchable.item';
import { SearchableSelectionType } from './interface/searchable.selection';
import { HistoryStage } from './history.stage';
import { SystemType } from './enums/system.type';

export class Stage implements SearchableItem {
  ID: string;
  NAME: string;
  DESCRIPTION: string;
  FLOW_SKIP: boolean;
  ORDER: number;
  TYPE: SystemType;

  HISTORY: HistoryStage[];

  active = false;
  selected = false;
  allowed = false;

  static parse(json: any): Stage {
    if (json) {
      const s = new Stage();

      s.ID = json.ID;
      s.NAME = json.NAME;
      s.DESCRIPTION = json.DESCRIPTION;
      s.ORDER = Number(json.ORDER);
      s.FLOW_SKIP = json.FLOW_SKIP;
      s.TYPE = SystemType[<string>json.TYPE];

      if (json.HISTORY)
        s.HISTORY = HistoryStage.parseArray(json.HISTORY);

      return s;
    } else return null;
  }

  static parseArray(json: any[]): Stage[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Stage.parse(j));

    return arr;
  }

  getName(): string {
    return this.NAME;
  }

  getFullDetails(): string {
    return this.NAME;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this.ID;
  }

  hasTransitions(): boolean {
    return !!this.HISTORY.length;
  }

  latestTransition(): HistoryStage {
    if (this.HISTORY)
      if (this.HISTORY.length)
        return this.HISTORY.reduce((m, v, i) => (v.DATE > m.DATE) && i ? v : m);
  }
}
